// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__15r9X","label":"LabeledBox_label__2syqZ"};